const customSelectors = {};
class customJS {
    constructor() {
       if (window.location.pathname.includes('/tools/recurring/portal/')) {
          document.querySelectorAll('[data-account-recharge-link]').forEach((els)=> {
            els.classList.remove('d-none');
          })
          document.querySelectorAll('[data-account-link]').forEach((els)=> {
            els.classList.add('d-none');
          })
          document.querySelectorAll('[data-search-link]').forEach((els)=> {
            els.classList.add('d-none');
          })
          document.querySelectorAll('[data-cart-link]').forEach((els)=> {
            els.classList.add('d-none');
          })
         
       } else {
          document.querySelectorAll('[data-account-recharge-link]').forEach((els)=> {
            els.classList.add('d-none');
          })
          document.querySelectorAll('[data-account-link]').forEach((els)=> {
            els.classList.remove('d-none');
          })
          document.querySelectorAll('[data-search-link]').forEach((els)=> {
            els.classList.remove('d-none');
          })
          document.querySelectorAll('[data-cart-link]').forEach((els)=> {
            els.classList.remove('d-none');
          })
       }
    }
}

typeof customJS !== 'undefined' && new customJS();
